import React from "react";
export var InstagramSvg = function (props) {
    var _a = props.size, size = _a === void 0 ? 55 : _a, _b = props.colorsType, colorsType = _b === void 0 ? "original" : _b, _c = props.thickLinesColor, thickLinesColor = _c === void 0 ? "#00000" : _c, _d = props.thinLinesColor, thinLinesColor = _d === void 0 ? "#fff" : _d, _e = props.northWestShade, northWestShade = _e === void 0 ? "" : _e, _f = props.radientsUrlid, radientsUrlid = _f === void 0 ? 234 : _f;
    var originalRadicalsAndColors = [
        "#fd5",
        "#ff543f",
        "#fc5245",
        "#e64771",
        "#d53e91",
        "#cc39a4",
        "#c837ab",
        "#4168c9",
        "#fff", // thinLinesColor
    ];
    var colors;
    switch (colorsType) {
        case "original": {
            colors = originalRadicalsAndColors;
            break;
        }
        case "custom": {
            colors = Array(9).fill(thickLinesColor);
            colors[7] = northWestShade !== null && northWestShade !== void 0 ? northWestShade : thickLinesColor;
            colors[8] = thinLinesColor;
            break;
        }
        default: {
            colors = originalRadicalsAndColors;
            break;
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", width: size, height: size, viewBox: "0 0 48 48" },
            React.createElement("radialGradient", { id: "yOrnnhliCrdS2gy~4tD8ma_Xy10Jcu1L2Su_gr1_".concat(radientsUrlid), cx: "19.38", cy: "42.035", r: "44.899", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0", stopColor: colors[0] }),
                React.createElement("stop", { offset: ".328", stopColor: colors[1] }),
                React.createElement("stop", { offset: ".348", stopColor: colors[2] }),
                React.createElement("stop", { offset: ".504", stopColor: colors[3] }),
                React.createElement("stop", { offset: ".643", stopColor: colors[4] }),
                React.createElement("stop", { offset: ".761", stopColor: colors[5] }),
                React.createElement("stop", { offset: ".841", stopColor: colors[6] })),
            React.createElement("path", { fill: "url(#yOrnnhliCrdS2gy~4tD8ma_Xy10Jcu1L2Su_gr1_".concat(radientsUrlid, ")"), d: "M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20\tc-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20\tC42.014,38.383,38.417,41.986,34.017,41.99z" }),
            React.createElement("radialGradient", { id: "yOrnnhliCrdS2gy~4tD8mb_Xy10Jcu1L2Su_gr2_".concat(radientsUrlid), cx: "11.786", cy: "5.54", r: "29.813", gradientTransform: "matrix(1 0 0 .6663 0 1.849)", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { offset: "0", stopColor: colors[7] }),
                React.createElement("stop", { offset: ".999", stopColor: colors[7], stopOpacity: "0" })),
            React.createElement("path", { fill: "url(#yOrnnhliCrdS2gy~4tD8mb_Xy10Jcu1L2Su_gr2_".concat(radientsUrlid, ")"), d: "M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20\tc-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20\tC42.014,38.383,38.417,41.986,34.017,41.99z" }),
            React.createElement("path", { fill: colors[8], d: "M24,31c-3.859,0-7-3.14-7-7s3.141-7,7-7s7,3.14,7,7S27.859,31,24,31z M24,19c-2.757,0-5,2.243-5,5\ts2.243,5,5,5s5-2.243,5-5S26.757,19,24,19z" }),
            React.createElement("circle", { cx: "31.5", cy: "16.5", r: "1.5", fill: colors[8] }),
            React.createElement("path", { fill: colors[8], d: "M30,37H18c-3.859,0-7-3.14-7-7V18c0-3.86,3.141-7,7-7h12c3.859,0,7,3.14,7,7v12\tC37,33.86,33.859,37,30,37z M18,13c-2.757,0-5,2.243-5,5v12c0,2.757,2.243,5,5,5h12c2.757,0,5-2.243,5-5V18c0-2.757-2.243-5-5-5H18z" }))));
};
//# sourceMappingURL=InstagramSvg.js.map